import { useEffect, useState } from "react";
import { BatteryFull, Signal, Wifi } from "lucide-react";
import { cn } from "@/lib/utils";
import "./phone-frame.css";

const fmtTime = (d) => `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;

/**
 * Premium telefon-ramme rundt ekte, interaktivt innhold (bredde 390 logiske px). Høyden settes med CSS på
 * `.phone-screen` av den som bruker rammen (standard 844 px). Statuslinjen viser faktisk klokkeslett.
 */
export function PhoneFrame({ children, className, screenClassName, time, testId = "phone-frame" }) {
  const [now, setNow] = useState(() => fmtTime(new Date()));
  useEffect(() => {
    if (time) return undefined;
    const t = setInterval(() => setNow(fmtTime(new Date())), 15_000);
    return () => clearInterval(t);
  }, [time]);
  return (
    <div className={cn("phone", className)} data-testid={testId}>
      <span className="phone-btn phone-btn-mute" aria-hidden /><span className="phone-btn phone-btn-volup" aria-hidden /><span className="phone-btn phone-btn-voldown" aria-hidden /><span className="phone-btn phone-btn-power" aria-hidden />
      <div className={cn("phone-screen", screenClassName)} data-testid={`${testId}-screen`}>
        <div className="phone-status" aria-hidden>
          <span className="phone-time">{time || now}</span>
          <span className="phone-island" />
          <span className="phone-status-icons"><Signal className="h-3.5 w-3.5" /><Wifi className="h-3.5 w-3.5" /><BatteryFull className="h-4 w-4" /></span>
        </div>
        <div className="phone-content">{children}</div>
        <div className="phone-home-area" aria-hidden><span className="phone-home" /></div>
        <span className="phone-glare" aria-hidden />
      </div>
    </div>
  );
}
